import { render } from "./AppleContainer.vue?vue&type=template&id=0274800e&scoped=true"
import script from "./AppleContainer.vue?vue&type=script&lang=js"
export * from "./AppleContainer.vue?vue&type=script&lang=js"

import "./AppleContainer.vue?vue&type=style&index=0&id=0274800e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0274800e"]])

export default __exports__